import { useNavigate } from 'react-router-dom';

import { TRACK } from '../../routes/routeConstants';

const useGoToTrackPage = () => {
  const navigate = useNavigate();

  const goToTrackPage = (packageId: string) => {
    navigate(`/${TRACK}/${packageId}`);
  };

  return { goToTrackPage };
};

export default useGoToTrackPage;
